<template>
    <div  :class="url_data === 'speakers' ? '': 'pb-20'">
        
        <h3 v-if="url_data === 'speakers' " class="w-full py-4 mt-12 text-4xl font-bold text-center text-pink-600">Speakers</h3>

        <div v-if="url_data === 'speakers'" class="mx-auto md:w-4/12">
            <div class="flex justify-center w-auto px-4 py-2 mx-4 mb-6 bg-pink-600 rounded-lg shadow-xl">
                <input  v-model="searchQuery" type="text" class="w-10/12 p-1 text-black bg-white rounded focus:outline-none" name="term" placeholder="Cerca uno speaker" id="term">
                <a href="" class="w-2/12 px-1 ml-1 text-right text-white">
                    <span class="">
                        <button type="button" title="Refresh page">
                            <i class="pt-1 material-icons">autorenew</i>
                        </button>
                    </span>
                </a>
            </div>
        </div>

        <ul v-if="resources.length" class="flex flex-row flex-wrap items-center justify-start w-full px-4">
            <li v-for="speaker in resultQuery" :key="speaker.id" class="flex flex-col items-center content-center justify-center w-6/12 p-4 cust-center md:w-3/12">
                <a :href="`/speaker/${speaker.slug}`">
                    <div class="w-32 h-32 bg-center bg-cover border-8 border-white border-solid rounded-full shadow-lg hover:shadow-xl" :style="`background-image: url('${speaker.portrait}')`"></div>
                    <p :class="url_data === '' ? 'text-white' : '' " class="pt-4 text-lg font-semibold text-center">{{ speaker.name }} {{ speaker.last_name }}</p>
                </a>
            </li>
        </ul>
        <div v-if="url_data === '' ">
            <a href="/speakers" class="block w-64 py-2 mx-auto text-base font-bold text-center text-white uppercase border-4 border-white rounded-lg shadow-2xl my-14 hover:bg-pink-600 hover:text-white hover:border-pink-600 hover:shadow-custom">vedi tutti</a>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'speakers'
        ],
        data(){
            return{
                url_data: null,
                searchQuery: null,
                resources: this.speakers,
            };
        },
        mounted(){
            this.url_data = window.location.pathname.split('/')[1];
        },
        computed: {
            resultQuery() {
                if(this.searchQuery){
                    return this.resources.filter((speaker)=>{
                        return this.searchQuery.toLowerCase().split(' ').every(v => speaker.name.toLowerCase().includes(v) + speaker.last_name.toLowerCase().includes(v))
                    })
                }
                else{
                    return this.resources;
                }
            }
        }
    }
</script>

<style>
    .cust-center {
        text-align: -webkit-center;
    }
</style>